<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    preserveAspectRatio="xMinYMin meet"
    class="icon"
  >
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans"
        d="M 13 0 C 7.9752618 0 4.8792619 0.49755829 3 1.03125 C 2.060369 1.2980959 1.4224661 1.5864312 1 1.8125 C 0.8635292 1.8855278 0.78748732 1.9634956 0.6875 2.03125 C 0.66228581 2.0483359 0.61635533 2.0464454 0.59375 2.0625 A 1.0001 1.0001 0 0 0 0.3125 2.28125 A 1.0001 1.0001 0 0 0 0.28125 2.28125 L 0.25 2.34375 A 1.0001 1.0001 0 0 0 0.15625 2.4375 L 0 2.5625 L 0 2.8125 A 1.0001 1.0001 0 0 0 0 2.9375 L 0 3 L 0 30 L 0 31.65625 L 0 49 A 1.0001 1.0001 0 1 0 2 49 L 2 30.65625 C 2.4181602 30.487337 3.0488063 30.255773 4.1875 29.96875 C 6.0926222 29.488538 9.0164907 29 13 29 C 16.901519 29 19.796945 29.962149 23.3125 30.96875 C 26.828055 31.975351 30.923728 33 37 33 C 44.024309 33 49.5 29.875 49.5 29.875 L 50 29.59375 L 50 29 L 50 4 L 50 2.3125 L 48.53125 3.125 C 47.711356 3.5688738 43.012571 6 37 6 C 32.224444 6 28.891201 4.5936225 25.375 3.09375 C 21.858799 1.5938775 18.159215 0 13 0 z M 13 2 C 17.755785 2 21.076951 3.4061225 24.59375 4.90625 C 28.110549 6.4063775 31.822556 8 37 8 C 42.382891 8 46.113678 6.4075976 48 5.5 L 48 28.34375 C 47.315323 28.711877 42.947642 31 37 31 C 31.147272 31 27.313195 30.024649 23.84375 29.03125 C 20.374305 28.037851 17.229481 27 13 27 C 8.8525093 27 5.7808778 27.511462 3.71875 28.03125 C 2.6060273 28.311727 2.5317278 28.414992 2 28.625 L 2 3.53125 C 2.2846178 3.3825288 2.7744529 3.1925475 3.5625 2.96875 C 5.2044881 2.5024417 8.1097382 2 13 2 z"
        overflow="visible"
        enable-background="accumulate"
        font-family="Bitstream Vera Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "flag",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
